import { render, staticRenderFns } from "./AddPageDataSidebar.vue?vue&type=template&id=354cce8c"
import script from "./AddPageDataSidebar.vue?vue&type=script&lang=js"
export * from "./AddPageDataSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports